import { useEffect, useState } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { creditFlagRender } from "@/utils/utils";
import { openDataModel } from "./openDataModel";
import { AccountOpenResult } from "@/views/contract/manage/ContractManageTypes";
import { formatLocalDateTime } from "@/utils/utils";

export function OpenDataTable() {

    const {
        loading, dataSource, selectedRowKeys, pgCfg,
        loadData, onSearch, setSelectedRowKeys, setSelectedData,
    } = openDataModel();


    const columns: ColumnsType<AccountOpenResult> = [
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
            width: 60,
        },
        {
            align: "center",
            title: '账户实体',
            dataIndex: 'beName',
            width: 200,
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            width: 120,
            render: (v) => creditFlagRender(v)
        },
        {
            align: "center",
            title: '记账类型',
            dataIndex: 'accountTypeName',
            width: 120,
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
            width: 120,
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'createUser',
            width: 120,
        },
        {
            align: "center",
            title: '申请日期',
            dataIndex: 'createTime',
            width: 140,
            render: (text) => formatLocalDateTime(text)
        },
        {
            align: "center",
            title: '审核员',
            dataIndex: 'approver',
            width: 120,
        },
        {
            align: "center",
            title: '审核日期',
            dataIndex: 'approvalTime',
            width: 140,
            render: (text) => formatLocalDateTime(text)
        },
        {
            align: "center",
            title: '审核状态',
            dataIndex: 'status',
            width: 120,
            render: (v) =>
                v === 0 ? '初始'
                    : v === 1 ? '审核中'
                        : v === 2 ? '审核通过'
                            : v === 3
                                ? '撤回'
                                : v === 8 ? '审核驳回'
                                    : v === 9 ? '失败'
                                        : ''
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
            width: 200,
        },
    ];

    useEffect(() => {
        onSearch();
    }, [])

    return (
        <>
            <Table
                loading={loading}
                rowKey={record => record.id}
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: AccountOpenResult[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setSelectedData(selectedRows);
                    }
                }}
                pagination={{
                    ...pgCfg,
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
            />
        </>
    )
}

